import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const batchTranslateLibrarySchedules = api(async function batchTranslateLibrarySchedules({ language }) {
    return mutate(
        gql`
            mutation BatchTranslateLibrarySchedules($language: String!) {
                batchTranslateLibrarySchedules(language: $language)
            }
        `,
        { language },
        { returns: "batchTranslateLibrarySchedules" }
    )
})

export const batchTranslateCustomSchedules = api(async function batchTranslateCustomSchedules({ language }) {
    return mutate(
        gql`
            mutation BatchTranslateCustomSchedules($language: String!) {
                batchTranslateCustomSchedules(language: $language)
            }
        `,
        { language },
        { returns: "batchTranslateCustomSchedules" }
    )
})

export const cancelBatchTranslation = api(async function cancelBatchTranslation({ jobId }) {
    return mutate(
        gql`
            mutation CancelBatchTranslation($jobId: String!) {
                cancelBatchTranslation(jobId: $jobId)
            }
        `,
        { jobId },
        { returns: "cancelBatchTranslation" }
    )
})

export const getBatchTranslationProgress = api(async function batchTranslationProgress({ jobId }) {
    return query(
        gql`
            query GetBatchTranslationProgress($jobId: String!) {
                batchTranslationProgress(jobId: $jobId) {
                    total
                    completed
                    failed
                    status
                    startedAt
                    completedAt
                }
            }
        `,
        { jobId },
        { returns: "batchTranslationProgress" }
    )
})
